import React, { createContext } from "react";
import { useQuery } from "react-query";
import PropTypes from "prop-types";
import featureFlagApi from "../services/featureFlagApi";

const FeatureFlagContext = createContext();

export { FeatureFlagContext };

export const FeatureFlagProvider = ({ children }) => {
  const { data: flags, isLoading } = useQuery(
    ["featureFlags", "all"],
    () => featureFlagApi.getAllFlags(),
  );

  const isEnabled = (flagName) => flags?.[flagName] === true;
  const isDisabled = (flagName) => flags?.[flagName] === false;

  const value = {
    flags: flags || {},
    isLoading,
    isEnabled,
    isDisabled,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

FeatureFlagProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
